"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactComponents = require("@cimpress/react-components");

var ClaimCategory = function ClaimCategory(_ref) {
  var category = _ref.category;
  // Remove trailing double pipe and replace all other double pipes with angle bracket
  var categoryPrettyPrint = category.replace(/\|\|$/, '').replace(/\|\|/gi, ' > ');
  return _react["default"].createElement("div", null, _react["default"].createElement(_reactComponents.Tag, {
    label: categoryPrettyPrint,
    removable: false
  }));
};

ClaimCategory.propTypes = {
  category: _propTypes["default"].string.isRequired
};
var _default = ClaimCategory;
exports["default"] = _default;